import { useNavigate } from 'react-router-dom';
import { Paths } from 'services/navigation/paths';

export const useGoBack = (fallBackPath: Paths) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallBackPath);
    }
  };

  return { handleGoBack };
};
